module.exports = __webpack_public_path__ + "static/media/hero-prod-right.01b7b680.png";